import portalApi from './portalApi';

const portalUploadService = {
  getDocumentRequests: () => portalApi.get('/portal/document-requests'),
  uploadDocument: (requestId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return portalApi.post(`/portal/document-requests/${requestId}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  getCaseNotes: (caseId) => portalApi.get(`/portal/cases/${caseId}/notes`),
};

export default portalUploadService;
